interface LocalStorageCommonProps {
    key: string;
}

interface SetLocalStorageProps extends LocalStorageCommonProps {
    value: string;
}

interface RemoveLocalStorageProps {
    keys: string[];
}

export const LOCAL_STORAGE = {
    set: ({ key, value }: SetLocalStorageProps) => {
        JSON.stringify(localStorage.setItem(key, value));
    },
    get: ({ key }: LocalStorageCommonProps) => localStorage.getItem(key) as string,
    remove: ({ keys }: RemoveLocalStorageProps) => {
        keys.map((key) => localStorage.removeItem(key));
    },
};
